import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

/** Core Rules p. 25 (exotic). */
export const celestial: AncestryDefinition = {
  id: 'celestial', name: 'Celestial', size: 'medium', trait: 'Highborn', skillBonus: 0, initiativeBonus: 0, highborn: true,
  description: 'Descendants of divine beings, Celestials carry an aura of nobility and grace. Their innate connection to the higher planes allows them to resist the effects of misfortune, standing strong where others may falter.',
  traitDescription: 'Your disadvantaged save is neutral instead.',
  languages: [{ id: 'celestial', name: 'Celestial', minimumIntelligence: 0 }],
  languageDescription: 'You know Celestial if your INT isn’t negative.',
  skinColors: [0xf1c9a5, 0xe0ac87, 0xc99776, 0xa8714f, 0x6b4129, 0x4a2c1d, 0xe4dfe0, 0xc9c6cf, 0xe2c08a, 0xc89a5a, 0x9a6232],
  hairColors: [0x1c1714, 0x422d25, 0x6b4428, 0x9a6a3c, 0xc9a165, 0xa64b2a, 0xf2efe8, 0xc4c8d0, 0xe3c77a, 0xb5602e, 0x9fb4d4, 0x4d6694],
};
export const celestialBodies: CharacterOptions['bodies'] = [
  { id: 'celestial-male', name: 'Masculine', height: [1.8, 2.05], ancestryId: 'celestial' },
  { id: 'celestial-female', name: 'Feminine', height: [1.7, 1.95], ancestryId: 'celestial' },
];
